import { useTranslation } from 'react-i18next';
import {
  TOGGLE_SECTION_BADGE_NEW,
  TOGGLE_SECTION_SIZE_L,
  TOGGLE_SECTION_SIZE_S,
  ToggleSection,
} from '@components/toggle-section';
import { TranslationFields } from '@components/translation-fields';
import { XS_VIEWPORT } from '@constants/viewport';
import { useWindowSize } from '@hooks/use-window-size';

import { TranslationSectionProps } from './translation-section.type';

export const TranslationSection = ({
  enabled,
  onEnabledChange,
  toggleLabel,
  toggleSubLabel,
  showNewBadge = true,
  disabled = false,
  className,
  ...fieldsProps
}: TranslationSectionProps) => {
  const { t } = useTranslation();
  const isMobileViewport = useWindowSize(XS_VIEWPORT);
  const size = isMobileViewport ? TOGGLE_SECTION_SIZE_S : TOGGLE_SECTION_SIZE_L;

  return (
    <ToggleSection
      value={enabled}
      onChange={onEnabledChange}
      label={toggleLabel ?? t('offers:enableTranslationsSectionTitle')}
      subLabel={toggleSubLabel ?? t('offers:enableTranslationsSectionSubtitle')}
      badge={showNewBadge && !isMobileViewport ? TOGGLE_SECTION_BADGE_NEW : undefined}
      size={size}
      disabled={disabled}
      className={className}>
      <TranslationFields {...fieldsProps} disabled={disabled} />
    </ToggleSection>
  );
};
